import { render, staticRenderFns } from "./AdminReferralPromotions.vue?vue&type=template&id=67443565&"
import script from "./AdminReferralPromotions.vue?vue&type=script&lang=js&"
export * from "./AdminReferralPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports